<template>
  <div class="app-table-actions text-center">
    <!-- begin:: Read Actions -->
    <router-link
      v-if="layoutActions.viewDetailsRouteName"
      :to="{
        name: layoutActions.viewDetailsRouteName,
        params: { id: item.id },
      }"
      class="btn btn-clean btn-icon"
    >
      <i class="icon-nm" :class="readOrEditIcons"></i>
    </router-link>
    <a
      v-else-if="layoutActions.isDownload"
      class="btn btn-clean btn-icon"
      @click="actionDownload(item)"
    >
      <i class="icon-nm" :class="readOrEditIcons"></i>
    </a>
    <a
      v-else-if="layoutActions.openUrl"
      :href="item.argoURL"
      target="_blank"
      class="btn btn-clean btn-icon"
    >
      <i class="icon-nm" :class="readOrEditIcons"></i>
    </a>
    <a
      v-else
      class="btn btn-clean btn-icon"
      @click="actionReadDetails(item.id)"
    >
      <i class="icon-nm" :class="readOrEditIcons"></i>
    </a>
    <a
      v-if="layoutActions.isShowDeleteButton"
      class="btn btn-clean btn-icon"
      @click="actionDelete(item.id)"
    >
      <i class="far fa-trash-alt icon-nm"></i>
    </a>
  </div>
</template>

<script>
import commonMixin from "@/core/mixins/common.mixin";

export default {
  name: "AppTableActions",
  mixins: [commonMixin],
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    layoutActions: {
      type: Object,
      default: () => {
        return {
          hasActionDelete: false,
          viewDetailsRouteName: "",
        };
      },
    },
    accessRights: {
      type: Object,
      default: () => {
        return {
          moduleName: "",
          actions: {
            create: "",
            read: "",
            update: "",
            delete: "",
          },
        };
      },
    },
    subMenu: {
      type: String,
      default: null,
    },
  },
  computed: {
    readOrEditIcons() {
      let accessRights = this.accessRights;
      if (!this.layoutActions.isDownload) {
        return "far fa-eye";
      } else if (this.layoutActions.isDownload) {
        return "fa fa-download";
      } else {
        return "far fa-eye";
      }
    },
    isShowDeleteButton() {
      return this.layoutActions.hasActionDelete;
    },
  },
  methods: {
    actionDelete(value) {
      this.$emit("app-table-actions-action-delete", value);
    },
    actionReadDetails(value) {
      this.$emit("app-table-actions-open-modal-details", value);
    },
    actionDownload(value) {
      this.$emit("app-table-actions-download", value);
    },
  },
};
</script>

<style></style>
